import React from "react";
import "./SubmissionLoader.css";

const SubmissionLoader = ({
  show = true,
  message = "Processing your assessment...",
}) => {
  if (!show) return null;

  return (
    <div className="submission-loader-overlay">
      <div className="submission-loader-container">
        {/* Animated background circles */}
        <div className="loader-bg-circles">
          <div className="circle circle-1"></div>
          <div className="circle circle-2"></div>
          <div className="circle circle-3"></div>
        </div>

        {/* Main loader content */}
        <div className="loader-content">
          {/* Animated spinner */}
          <div className="loader-spinner">
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
          </div>

          {/* Progress steps */}
          <div className="loader-steps">
            <div className="step step-1 active">
              <div className="step-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path>
                </svg>
              </div>
              <span className="step-text">Submitting Assessment</span>
            </div>
            <div className="connectorLine"></div>
            <div className="step step-2">
              <div className="step-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                </svg>
              </div>
              <span className="step-text">Sending Email</span>
            </div>
            <div className="connectorLine"></div>
            <div className="step step-3">
              <div className="step-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                </svg>
              </div>
              <span className="step-text">Loading Results</span>
            </div>
          </div>

          {/* Main message */}
          <p className="loader-message">{message}</p>

          {/* Sub-message */}
          <p className="loader-submessage">
            Please wait while we process your assessment...
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubmissionLoader;
